
    <div class="modal-header">
        <div class="row">
            <h4 class="modal-title fw-bold">
                <span *ngIf="isBreedingMethodScreen && !isPreview" jhiTranslate="design-crosses.breeding.method.header"></span>
                <span *ngIf="!isBreedingMethodScreen && !isPreview" jhiTranslate="design-crosses.naming.and.harvest.header"></span>
                <span *ngIf="isPreview" jhiTranslate="design-crosses.review.crosses"></span>
            </h4>
        </div>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true"
                (click)="close()">
        </button>
    </div>
    <div class="modal-body">
        <div *ngIf="isBreedingMethodScreen && !isPreview">
            <div class="col-sm-12">
                <div class="row">
                    <span jhiTranslate="design-crosses.breeding.method.label"></span>
                </div>
                <br/>
				<div class="row d-flex align-items-center mb-3">
					<div class="col">
						<input type="radio" id="selectMethodInImportFile" name="selectMethodInImportFile" [(ngModel)]="breedingMethodRadio" [value]="1" (change)="updateShowApplyGroupingCheckBoxValue()" checked>
						<label for="selectMethodInImportFile" class="ms-1" jhiTranslate="design-crosses.breeding.method.import.file">Use the breeding methods specified in the import file</label>
					</div>
				</div>
				<div class="row d-flex align-items-center mb-3">
					<div class="col">
						<input type="radio" id="useParentalStatus" name="useParentalStatus" [(ngModel)]="breedingMethodRadio" [value]="2" (change)="updateShowApplyGroupingCheckBoxValue()" checked>
						<label for="useParentalStatus" class="ms-1" jhiTranslate="design-crosses.breeding.method.parental.status">Use parental status</label>
					</div>
				</div>
				<div class="row d-flex align-items-center mb-3">
					<div class="col">
						<input type="radio" id="selectMethod" name="selectMethod" [(ngModel)]="breedingMethodRadio" [value]="3" (change)="updateShowApplyGroupingCheckBoxValue()" checked>
						<label for="selectMethod" class="ms-1" jhiTranslate="design-crosses.breeding.method.select.method">Select a method to use for all crosses :</label>
					</div>
				</div>
                <div class="row">
                    <div class="col-sm-6">
                        <jhi-breeding-methods-select [(value)]="breedingMethodSelectedId"
                                                     [disabled]="disableBreedingMethodSelect"
                                                     [selectWidth]="'90%'"
                                                     [showAllMethodTypesOption]="false"
                                                     [showDerivativeMethodTypesOption]="false"
                                                     [showGenerativeMethodTypesOption]="false"
                                                     [breedingMethodFilterTypeValue]="BreedingMethodFilterTypeEnum.GENERATIVE_ONLY"
                                                     [showFavoritesCheckbox]="true"
                                                     [helpLink]="breedingMethodHelpLink"
                                                     (onMethodChanged)="updateShowApplyGroupingCheckBoxValue()"
                        ></jhi-breeding-methods-select>
                    </div>
                </div>
                <div *ngIf="showApplyGroupingCheckBox" class="row">
                    <div class="col">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" name="applyGroupingToNewCrossesOnly" id="applyGroupingToNewCrossesOnly" [(ngModel)]="applyGroupingToNewCrossesOnly">
                            <label class="form-check-label" for="applyGroupingToNewCrossesOnly" jhiTranslate="design-crosses.breeding.method.apply.grouping"></label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="!isBreedingMethodScreen && !isPreview">
            <div>
                <div class="row">
                    <span jhiTranslate="design-crosses.naming.and.harvest.label"></span>
                </div>
                <br/>
                <h4 class="row">
                    <span jhiTranslate="design-crosses.naming.and.harvest.naming.label">Naming</span>
                </h4>
                <div class="row col-sm-12">
					<div class="row d-flex align-items-center mb-3">
						<div class="col">
							<input type="radio" id="isFilePreferredName" name="isFilePreferredName" [(ngModel)]="namingRadio" [value]="0" checked>
							<label class="ms-1" for="isFilePreferredName" jhiTranslate="design-crosses.naming.and.harvest.naming.import.preferred">Use preferred name specified in the import file</label>
						</div>
					</div>
					<div class="row d-flex align-items-center mb-3">
						<div class="col">
							<input type="radio" id="isAutomaticNaming" name="isAutomaticNaming" [(ngModel)]="namingRadio" [value]="1">
							<label class="ms-1" for="isAutomaticNaming" jhiTranslate="design-crosses.naming.and.harvest.naming.automatic">Use automatic name generation</label>
						</div>
					</div>
					<div class="row d-flex align-items-center mb-3">
						<div class="col">
							<input type="radio" id="specifyNameFormat" name="specifyNameFormat" [(ngModel)]="namingRadio" [value]="2">
							<label class="ms-1" for="specifyNameFormat" jhiTranslate="design-crosses.naming.and.harvest.naming.specify">Specify name format</label>
						</div>
					</div>
                </div>
                <div *ngIf="isManualNaming()">
                    <br/>
                    <span jhiTranslate="design-crosses.naming.and.harvest.naming.specify.label">You can define new settings or load previously saved settings. Note that * indicates a mandatory field.</span>
                    <div class="mb-3 row">
                        <label class="col-sm-5 col-form-label fw-bold" jhiTranslate="design-crosses.naming.and.harvest.load.settings"> Load saved settings: </label>
                        <div class="col-sm-4" style="padding-left: 0px;">
                            <select class="form-select" [(ngModel)]="presetSettingId" (ngModelChange)="applySelectedSetting()">
                                <option [value]="0" jhiTranslate="study-editor.basic-details.pleaseChoose"></option>
                                <option *ngFor="let presetSetting of presetSettings" [value]="presetSetting.id">{{presetSetting.name}}</option>
                            </select>
                        </div>
                        <div class="col-md-1">
                            <button class="btn btn-outline-secondary" *ngIf="presetSettingId!=0" (click)="deleteSelectedSetting()"><span class="fa fa-trash"></span></button>
                        </div>
                    </div>
                    <br/>
                    <span jhiTranslate="design-crosses.naming.and.harvest.cross.code.label"></span>
                    <div class="mb-3 row required">
                        <label class="col-sm-5 col-form-label fw-bold" jhiTranslate="design-crosses.naming.and.harvest.cross.code.prefix">Cross code prefix</label>
                        <div class="col-sm-5">
                            <input type="text" class="form-control"  id="crossCodePrefix" [(ngModel)]="crossNameSetting.prefix" (change)="getNextNameSequence()" required>
                        </div>
                    </div>
                    <div class="mb-3 row">
                        <label class="col-sm-5 col-form-label fw-bold" jhiTranslate="design-crosses.naming.and.harvest.sequence.number"></label>
                        <div class="col-sm-5">
                            <select class="form-select" name="sequenceNumber" id="sequenceNumber" [(ngModel)]="crossNameSetting.numOfDigits" (change)="getNextNameSequence()">
                                <option *ngFor="let number of numbers" [value]="number">{{number}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="mb-3 row">
                        <label class="col-sm-5 col-form-label fw-bold" jhiTranslate="design-crosses.naming.and.harvest.cross.code.suffix">Cross code suffix</label>
                        <div class="col-sm-5">
                            <input type="text" class="form-control"  id="crossCodeSuffix" [(ngModel)]="crossNameSetting.suffix" (change)="getNextNameSequence()">
                        </div>
                    </div>
                    <div class="mb-3 row">
                        <label class="col-sm-5 col-form-label fw-bold" jhiTranslate="design-crosses.naming.and.harvest.prefix.space"></label>
                        <div class="col-sm-5 d-flex align-items-center">
                            <div class="mb-3">
                                <input type="radio" id="prefixSpaceYes" name="prefixSpaceYes" [(ngModel)]="crossNameSetting.addSpaceBetweenPrefixAndCode" [value]="true" (change)="getNextNameSequence()">
                                <label class="ms-1" for="prefixSpaceYes" jhiTranslate="yes">Yes</label>
                            </div>
                            <div class="mb-3">
                                <input class="ms-3" type="radio" id="prefixSpaceNo" name="prefixSpaceNo" [(ngModel)]="crossNameSetting.addSpaceBetweenPrefixAndCode" [value]="false" (change)="getNextNameSequence()">
                                <label class="ms-1" for="prefixSpaceNo" jhiTranslate="no">No</label>
                            </div>
                        </div>
                    </div>
                    <div class="mb-3 row">
                        <label class="col-sm-5 col-form-label fw-bold" jhiTranslate="design-crosses.naming.and.harvest.suffix.space"></label>
                        <div class="col-sm-5 d-flex align-items-center">
                            <div class="mb-3">
                                <input type="radio" id="suffixSpaceYes" name="suffixSpaceYes" [(ngModel)]="crossNameSetting.addSpaceBetweenSuffixAndCode" [value]="true" (change)="getNextNameSequence()">
                                <label class="ms-1" for="suffixSpaceYes" jhiTranslate="yes">Yes</label>
                            </div>
                            <div class="mb-3">
                                <input class="ms-3" type="radio" id="suffixSpaceNo" name="suffixSpaceNo" [(ngModel)]="crossNameSetting.addSpaceBetweenSuffixAndCode" [value]="false" (change)="getNextNameSequence()">
                                <label class="ms-1" for="suffixSpaceNo" jhiTranslate="no">No</label>
                            </div>
                        </div>
                    </div>
                    <div class="mb-3 row">
                        <label class="col-sm-5 col-form-label" ></label>
                        <div class="col-sm-5 d-flex align-items-center">
                            <span><i jhiTranslate="study-editor.import-crosses-settings.field.next-name">Next name in sequence: </i>{{nextNameInSequence}}</span>
                        </div>
                    </div>
                    <div class="mb-3 row">
                        <label class="col-sm-5 col-form-label fw-bold" jhiTranslate="design-crosses.naming.and.harvest.start.sequence"></label>
                        <div class="col-sm-5">
                            <input type="number" class="form-control"  id="startingSequenceNumber" [(ngModel)]="crossNameSetting.startNumber" (change)="getNextNameSequence()">
                        </div>
                    </div>
                    <div class="mb-3 row">
                        <label class="col-sm-5 col-form-label fw-bold" jhiTranslate="design-crosses.naming.and.harvest.separator"></label>
                        <div class="col-sm-5">
                            <input type="text" class="form-control"  id="separator" [(ngModel)]="crossNameSetting.separator" (change)="updateSampleParentageDesignation()">
                        </div>
                    </div>
                    <div class="mb-3 row">
                        <label class="col-sm-5 col-form-label" ></label>
                        <div class="col-sm-5 d-flex align-items-center">
                            <span><i jhiTranslate="study-editor.import-crosses-settings.field.example-parentage-desig">Example parentage designation: </i>{{sampleParentageDesignation}}</span>
                        </div>
                    </div>
                    <div class="mb-3 row">
                        <label class="col-sm-5 col-form-label fw-bold" jhiTranslate="design-crosses.naming.and.harvest.save.parentage.designation"></label>
                        <div class="col-sm-5 d-flex align-items-center">
                            <div class="mb-3">
                                <input type="radio" id="saveParentageYes" name="saveParentageYes" [(ngModel)]="crossNameSetting.saveParentageDesignationAsAString" [value]="true" checked>
                                <label class="ms-1" for="saveParentageYes" jhiTranslate="yes">Yes</label>
                            </div>
                            <div class="mb-3">
                                <input class="ms-3" type="radio" id="saveParentageNo" name="saveParentageNo" [(ngModel)]="crossNameSetting.saveParentageDesignationAsAString" [value]="false" checked>
                                <label class="ms-1" for="saveParentageNo" jhiTranslate="no">No</label>
                            </div>
                        </div>
                    </div>
                    <div class="float-end" style="padding-right: 24px">
						<button (click)="saveCrossingNamePreset()" class="btn btn-primary" jhiTranslate="advance-study.attributes.preset.save.setting"></button>
                    </div>
                </div>
            </div>
            <br/>
            <div>
                <h4 class="row">
                    <span jhiTranslate="design-crosses.naming.and.harvest.harvest.label">Harvest Details</span>
                </h4>
                <div class="mb-3 row required">
                    <div class="col-3">
                        <label for="harvestDate" class="col-form-label fw-bold" jhiTranslate="design-crosses.naming.and.harvest.estimated.harvest.date">Estimated harvest date:</label>
                    </div>
                   <div class="col-6">
                       <div class="input-group col">
                           <input class="form-control" [placeholder]="'global.date.placeholder' | translate" [(ngModel)]="estimatedHarvestDate"
                                  ngbDatepicker #harvestDate="ngbDatepicker" id="harvestDate" name="harvestDate" required/>
                           <button class="btn btn-outline-secondary calendar" (click)="harvestDate.toggle()" type="button"><i class="fa fa-calendar"></i></button>
                       </div>
                   </div>
                </div>
                <div class="mb-3 row required">
                    <div class="col-3">
                        <label class="col-form-label fw-bold" jhiTranslate="design-crosses.naming.and.harvest.harvest.location">Harvest location:</label>
                    </div>
                    <div class="col-6">
                        <jhi-locations-select
                                [(value)]="locationId"
                                [selectWidth]="'90%'"
                                [helpLink]="harvestLocationHelpLink"
                                [showFilterOptions]="true">
                        </jhi-locations-select>
                    </div>
                </div>
            </div>
            <div>
                <h4 class="row">
                    <span jhiTranslate="design-crosses.naming.and.harvest.alerts">Alerts</span>
                </h4>
                <div class="row">
                    <div class="col">
                        <input class="form-check-input" type="checkbox" name="crossesExistsAlert" id="crossesExistsAlert" [(ngModel)]="checkExistingCrosses">
                        <label class="form-check-label ms-2" for="crossesExistsAlert" jhiTranslate="design-crosses.naming.and.harvest.exists.alerts"></label>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="isPreview">
            <div *ngIf="checkExistingCrosses">
                <div class="row">
                    <div class="col">
                        <input class="form-check-input" type="checkbox" name="showRecordsWithAlerts" id="showRecordsWithAlerts" [(ngModel)]="showRecordsWithAlerts" (change)="updateDisplayedEntries()" [disabled]="omitAlertedCrosses">
                        <label class="form-check-label ms-2" for="showRecordsWithAlerts" jhiTranslate="study-editor.import-crosses-settings.field.show-records-alert">Show only records with alerts</label>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <input class="form-check-input" type="checkbox" name="omitAlertedCrosses" id="omitAlertedCrosses" [(ngModel)]="omitAlertedCrosses" (change)="updateDisplayedEntries()">
                        <label class="form-check-label ms-2" for="omitAlertedCrosses" jhiTranslate="study-editor.import-crosses-settings.field.omit-records-alert">Omit alerted crosses</label>
                    </div>
                </div>
            </div>
            <div *ngIf="hasPlotDuplicates">
                <div class="row">
                    <div class="col">
                        <input class="form-check-input" type="checkbox" name="showRecordsWithAlerts" id="omitPlotDuplicates" [(ngModel)]="omitPlotDuplicates" (change)="updateDisplayedEntries()">
                        <label class="form-check-label ms-2" for="showRecordsWithAlerts" jhiTranslate="study-editor.import-crosses-settings.field.omit-plot-duplicates">Omit plot duplicates</label>
                    </div>
                </div>
            </div>
            <br/>
            <div class="table-responsive p-3" *ngIf="currentPagePreviewList">
                <div class="custom-scroll-style" style="max-height: 400px; overflow-y: auto; overflow-x: auto;">
                <table id="crosses-preview-table" class="table table-striped table-bordered table-curved">
                    <thead class="sticky-header">
                    <tr>
                        <th *ngIf="checkExistingCrosses" scope="col">
                            <span jhiTranslate="study-editor.import-crosses-settings.column.alerts">ALERTS</span>
                        </th>
                        <th scope="col">
                            <span>#</span>
                        </th>
                        <th scope="col" >
                            <span jhiTranslate="design-crosses.preview.table.cross"></span>
                        </th>
						<th scope="col">
							<span jhiTranslate="design-crosses.preview.table.duplicate"></span>
						</th>
                        <th scope="col" >
                            <span jhiTranslate="design-crosses.preview.table.female.pedigree"></span>
                        </th>
                        <th scope="col" >
                            <span jhiTranslate="design-crosses.preview.table.female.parent"></span>
                        </th>
                        <th scope="col" >
                            <span jhiTranslate="design-crosses.preview.table.male.pedigree"></span>
                        </th>
                        <th scope="col" >
                            <span jhiTranslate="design-crosses.preview.table.male.parent"></span>
                        </th>
                        <th scope="col" >
                            <span jhiTranslate="design-crosses.preview.table.breeding.method"></span>
                        </th>
                        <th scope="col" >
                            <span jhiTranslate="design-crosses.preview.table.germplasm.origin"></span>
                        </th>
                    </tr>
                    </thead>
                    <tbody *ngIf="currentPagePreviewList.length else nodata">
                    <tr *ngFor="let previewCross of currentPagePreviewList">
                        <td *ngIf="checkExistingCrosses">
                            <a *ngIf="previewCross.hasExistingCrosses" class="gid-link" href="javascript: void(0)"
                               (click)="viewExistingCrosses(previewCross)" jhiTranslate="study-editor.import-crosses-settings.view-existing">View Existing Crosses</a>
                        </td>
                        <td>{{previewCross.entryNumber}}</td>
						<td><truncate-span [textInput]="previewCross.cross" [maxLength]="MAX_NAME_DISPLAY_SIZE"></truncate-span></td>
                        <td class="duplicate-column-td">
                            <ng-container *ngFor="let duplicatePrefix of Object.keys(previewCross.duplicateOrderedMap)">
                                <span [ngClass]="{
                                    'plotDupe': duplicatePrefix === PLOT_DUPE_PREFIX,
                                    'pedigreeDupe': duplicatePrefix === PEDIGREE_DUPE_PREFIX,
                                    'plotRecip': duplicatePrefix === PLOT_RECIP_PREFIX,
                                    'pedigreeRecip': duplicatePrefix === PEDIGREE_RECIP_PREFIX}">
                                    {{ getDuplicatePrefixString(duplicatePrefix) | translate }}: {{ previewCross.duplicateOrderedMap[duplicatePrefix] }}
                                </span>
                            </ng-container>
                        </td>
						<td><truncate-span [textInput]="previewCross.femalePedigreeString" [maxLength]="MAX_NAME_DISPLAY_SIZE"></truncate-span></td>
						<td *ngIf="previewCross.femaleParents[0].gid === 0">{{previewCross.femaleParents[0].designation}}</td>
						<td *ngIf="previewCross.femaleParents[0].gid !== 0">
							<jhi-expandable-cell [data]="getNames(previewCross.femaleParents)" [asLink]="true" (itemClick)="openGermplasmDetailsInTab(previewCross.femaleParents[$event].gid)"></jhi-expandable-cell>
						</td>
						<td><truncate-span [textInput]="previewCross.malePedigreeString" [maxLength]="MAX_NAME_DISPLAY_SIZE"></truncate-span></td>
						<td *ngIf="previewCross.maleParents[0].gid === 0"><truncate-span [textInput]="previewCross.maleParents[0].designation" [maxLength]="MAX_NAME_DISPLAY_SIZE"></truncate-span></td>
						<td *ngIf="previewCross.maleParents[0].gid !== 0">
							<jhi-expandable-cell [data]="getNames(previewCross.maleParents)" [asLink]="true" (itemClick)="openGermplasmDetailsInTab(previewCross.maleParents[$event].gid)"></jhi-expandable-cell>
						</td>
						<td>{{previewCross.breedingMethodName}}</td>
						<td><truncate-span [textInput]="previewCross.seedSource" [maxLength]="MAX_NAME_DISPLAY_SIZE"></truncate-span></td>
                    </tr>
                    </tbody>
                </table>
                <ng-template #nodata>
                    <tbody>
                    <tr>
                        <td colspan="9" jhiTranslate="no.data"></td>
                    </tr>
                    </tbody>
                </ng-template>
                </div>
            </div>

            <div *ngIf="currentPagePreviewList && currentPagePreviewList.length">
                <div class="row">
                    <div class="col">
                        <div class="pagination-container">
                            <div class="pagination-box pagination-box-left">
                                <div>
                                    <jhi-item-count [page]="page" [total]="totalItems" [itemsPerPage]="itemsPerPage"></jhi-item-count>
                                </div>
                            </div>
                            <div class="pagination-box">
                                <ngb-pagination [collectionSize]="totalItems" [(page)]="page" [pageSize]="itemsPerPage" [disabled]="isLoading"
                                                [maxSize]="3" [rotate]="true" [boundaryLinks]="true" (pageChange)="loadPage(page)"></ngb-pagination>
                            </div>
                            <div class="pagination-box pagination-box-right">
                                <div class="d-flex align-items-center">
                                    <label for="itemsPerPage" class="control-label control-label-left" jhiTranslate="global.items.per.page"></label>
                                    <select [(ngModel)]="itemsPerPage" class="form-select ms-2" id="itemsPerPage" [disabled]="isLoading"
                                            (change)="resetTable();" style="width:95px">
                                        <option value="10">10</option>
                                        <option value="20">20</option>
                                        <option value="50">50</option>
                                        <option value="75">75</option>
                                        <option value="100">100</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button *ngIf="isBreedingMethodScreen && !isPreview" [disabled]="(breedingMethodRadio === 3 && !breedingMethodSelectedId) || isLoading"
				(click)="goToNamingScreen()" class="btn btn-primary" jhiTranslate="continue">
            <span *ngIf="isLoading" class="throbber throbber-btn"></span>
        </button>
        <button *ngIf="!isBreedingMethodScreen && !isPreview" (click)="goBackToBreedingMethodScreen()" class="btn btn-secondary" jhiTranslate="back">
        </button>
        <button *ngIf="!isBreedingMethodScreen && !isPreview" (click)="goToCrossesPreview()" [disabled]="disableGoToCrossesPreview()"
				class="btn btn-primary"  jhiTranslate="continue">
            <span *ngIf="isLoading" class="throbber throbber-btn"></span>
        </button>
        <button *ngIf="isPreview" (click)="goToNamingScreen()" class="btn btn-secondary" jhiTranslate="back">
        </button>
        <button *ngIf="isPreview" [disabled]="isLoading" (click)="saveCrosses()" class="btn btn-primary" jhiTranslate="finish">
            <span *ngIf="isLoading" class="throbber throbber-btn"></span>
        </button>
    </div>
